import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PercentagePipe } from '@shared/pipes/percentage.pipe';
import { ITEM } from '@utils/constants';

@Component({
  selector: 'app-sales-progress-bar',
  standalone: true,
  imports: [TranslatePipe, PercentagePipe],
  templateUrl: './sales-progress-bar.component.html',
  styleUrl: './sales-progress-bar.component.scss'
})
export class SalesProgressBarComponent {
  purchasePercentage = input<number>(ITEM.DEFAULT_VALUE);
}
